import React from 'react'

export default function Header({
  lang,
  config,
  homeConfig,
  pageIndex,
  onNavClick,
  onSwitchLang
}) {
  const isEn = lang === 'en'

  return (
    <header className="flex align-start between page-header">
      <section className="flex-0 flex header-nav">
        <a
          href={isEn ? './?lang=en' : './'}
          target="_self"
          rel="noopener noreferrer"
        >
          <img src={`${config.imgBase}game_logo.png`} alt="暴风怕死队" />
        </a>
        <a
          href="javascript:void(0);"
          data-lang={lang}
          className={pageIndex === 0 ? 'active' : ''}
          onClick={e => {
            e.preventDefault()
            onNavClick(0)
          }}
          target="_self"
          rel="noopener noreferrer"
        />
        <a
          href="javascript:void(0);"
          data-lang={lang}
          className={pageIndex === 1 ? 'active' : ''}
          onClick={e => {
            e.preventDefault()
            onNavClick(1)
          }}
          target="_self"
          rel="noopener noreferrer"
        />
        <a
          href="javascript:void(0);"
          data-lang={lang}
          className={pageIndex === 2 ? 'active' : ''}
          onClick={e => {
            e.preventDefault()
            onNavClick(2)
          }}
          target="_self"
          rel="noopener noreferrer"
        />
        {homeConfig.services ? (
          <a
            href={homeConfig.services}
            data-lang={lang}
            target="_self"
            rel="noopener noreferrer"
          />
        ) : null}
      </section>

      <section className="flex-0 header-links">
        <ul className="flex">
          {config.socials.map(item => (
            <li key={item.type}>
              {item.href && item.href.startsWith('http') ? (
                <a href={item.href} target="_blank" rel="noopener noreferrer">
                  <img src={`${config.imgBase}${item.img}`} alt={item.alt} />
                </a>
              ) : (
                <img src={`${config.imgBase}${item.img}`} alt={item.alt} />
              )}
              {item.qrcode ? (
                <div className="qq-qrcode">
                  <img src={`${config.imgBase}${item.qrcode}`} alt="qq群二维码" />
                </div>
              ) : null}
            </li>
          ))}
          <li>
            <img src="./images/icon_langs.png" alt="语言" />
            <div className="lang-items">
              <a
                className={lang === 'en' ? 'active' : ''}
                href="javascript:void(0);"
                onClick={e => {
                  e.preventDefault()
                  onSwitchLang('en')
                }}
                target="_self"
                rel="noopener noreferrer"
              >
                English
              </a>
              <a
                className={lang === 'zh' ? 'active' : ''}
                href="javascript:void(0);"
                onClick={e => {
                  e.preventDefault()
                  onSwitchLang('zh')
                }}
                target="_self"
                rel="noopener noreferrer"
              >
                中文
              </a>
            </div>
          </li>
        </ul>
      </section>
    </header>
  )
}
